module.exports = __webpack_public_path__ + "static/media/arrow-next.19fe1f19.svg";